module.exports = {
  oneClick: {
    saveCardCheckboxLabel: 'Saya ingin menyimpan kartu ini untuk pembelian di masa mendatang.',
    cardInfoLabel: '{brand} akhiran {lastFour}',
    newCreditCardLabel: 'Gunakan kartu kredit lain',
  },
  creditcardButtonMessage: 'Bayar dengan kartu kredit',
  debitcardButtonMessage: 'Bayar dengan kartu debit',
  externalpayproviderButtonMessage: 'Bayar menggunakan Fawry',
  banktransferButtonMessage: 'Bayar dengan transfer bank',
  cardNumberLabel: 'Nomor kartu',
  methodName: {
    creditcard: 'Kartu kredit',
    debitcard: 'Kartu debit',
    externalpayprovider: 'Fawry',
    paymob: 'Dompet Seluler',
  },
  info: {
    paymob: {
      payButton: 'Bayar dengan Dompet Seluler',
      phoneNumber: 'Setelah mengonfirmasi, Anda akan diarahkan secara otomatis ke dompet Anda.',
      title: 'Bayar dengan mudah menggunakan dompet seluler Anda!',
      description: 'Anda dapat menyelesaikan pembayaran menggunakan dompet seluler mana pun yang diotorisasi oleh Bank Sentral Mesir — nikmati transaksi yang cepat, aman, dan nyaman langsung dari ponsel Anda.',
    },
  },
};
